import React, { useEffect, useState } from 'react'
import AdminDashboard from '../AdminDashboard/AdminDashboard'
import { Message } from '../../../components/message'
import { useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon } from '../../../components/Application/ApplicationIcon';
import { Modal, Table } from 'react-bootstrap';
import sortByIcon from '../../../assets/images/sort.png';
import { adminUserListCsv, adminUserListExcel, adminUserListPdf, allAdminUserDataSort, allAdminUserList, deleteAdminUserData, getEnableDisableAdminUserData } from '../../../services/api/admin';
import { DeleteIcon, EditIcon, EyeIcon, PermissionIcon } from '../AdminIcon';
import ReactPaginate from 'react-paginate';
import { HiPlus } from 'react-icons/hi';
import { formatDateWithSlash, printData } from '../../../Utils/common';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { checkPermission , permissionsConfig } from '../AdminPermission/PermissionChecker';
import NotFoundTable from '../../../components/notFound/NotFoundTable';
import { CgLock, CgPassword } from 'react-icons/cg';
import { PdfBaseUrl } from '../../../Utils/Utils';
import { Spinner } from "react-bootstrap";
import TotalRecords from '../../../components/notFound/TotalRecords';

const AdminUsers = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [apiMessage, setApiMessage] = useState({ type: '', message: '' });
    const [userList, setuserList] = useState([])
    const [orderBy, setOrderBy] = useState("asc");
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteData, setDeleteData] = useState();
    const [totalPages, setTotalPages] = useState(0); // Total number of pages
    const [tableDataLoaded, setTableDataLoaded] = useState(false);
    const [searchTerm, setSearchTerm] = useState();
    const [sortBy, setSortBy] = useState("created_at");
    const [searchData, setSearchData] = useState("");
    const [pdfDownLoading, setPdfDownLoading] = useState(false);
    const [changingStatus, setChangingStatus] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);
    
    useEffect(() => {
        if (state && state.message) {
            setApiMessage({ type: 'success', message: state.message });
            // Clear the message once it is rendered
            window.history.replaceState({}, document.title);
        }
    }, [state])

    const grantPermissionForAddAdminUser = checkPermission(permissionsConfig.addAdminUser.role, permissionsConfig.addAdminUser.action, permissionsConfig.addAdminUser.type);
    const grantPermissionForEditAdminUser = checkPermission(permissionsConfig.editAdminUser.role, permissionsConfig.editAdminUser.action, permissionsConfig.editAdminUser.type);
    const grantPermissionForDeleteAdminUser = checkPermission(permissionsConfig.deleteAdminUser.role, permissionsConfig.deleteAdminUser.action, permissionsConfig.deleteAdminUser.type);
  

    useEffect(() => {
        getAdminUserList("created_at", "1", "desc", "");
    }, [])

    const getAdminUserList = async (sortBy, pageNo, orderBy, searchBy) => {
        try {
            setSearchData(searchBy);
            setOrderBy(orderBy);
            setSortBy(sortBy);
            const data = await allAdminUserList(sortBy, orderBy, searchBy, pageNo)
            if (data.status == 200) {
                setuserList(data?.data?.data)
                setTotalPages(Math.ceil(data?.data?.total / data?.data?.per_page)); // Calculate total pages
                setCurrentPage(pageNo > 0 ? pageNo - 1 : pageNo);
                setTotalRecords(data?.data?.total ? data?.data?.total : 0);
            } else {
                setuserList([]);
                setApiMessage({ type: "error", message: data?.message });
                setTotalRecords(0);
            }
            setTableDataLoaded(true)
            
        } catch (err) {
            setTotalRecords(0);
            setApiMessage({ type: 'err', message: err.message });
            setTableDataLoaded(true)
        }
    }

    const handleEnableDisable = async (e, item) => {
        try {
            setChangingStatus(item?.id)
            const formData = new FormData();
            formData.append("status", e?.value)
            formData.append("user_id",  item.id)
            const data = await getEnableDisableAdminUserData(formData)
            if (data?.status == 200) {
                getAdminUserList(sortBy, currentPage + 1, orderBy, searchData);
            } else {
                setApiMessage({ type: "error", message: data?.message });
            }
            setChangingStatus(null)
        } catch (err) {
            setChangingStatus(null)
            setApiMessage({ type: 'err', message: err.message });
        }
    }

    const handlePageChange = (selectedPage) => {
        getAdminUserList(sortBy, selectedPage.selected + 1, orderBy, searchData); // Increment by 1 if the API starts page numbers from 1
    };

    const deleteCategory = async (obj) => {
        try {
            const data = await deleteAdminUserData(obj.id)
            if (data?.status == 200) {
                getAdminUserList(sortBy, currentPage, orderBy, searchData);
                setDeleteData("");
                setApiMessage({ type: 'success', message: data.message });
            } else {
                setDeleteData("");
                setApiMessage({ type: 'err', message: data.message });
            }
        } catch (error) {
            //console.error(error);
        }
    }

    const pdfDownload = async () => {
        try {
            setPdfDownLoading(true)
            const response = await adminUserListPdf()
            setPdfDownLoading(false)
            window.open(`${PdfBaseUrl()}/${response.folder_path}/${response.file_name}`);
        } catch (err) {
            setPdfDownLoading(false)
            setApiMessage({ type: "error", message: err?.message })
        }
    }

    const excelDownload = async () => {
        try {
          const response = await adminUserListExcel()
          window.open(response?.file_path);
        } catch (err) {
          setApiMessage({ type: "error", message: err?.message })
        }
      }
    
      const csvDownload = async () => {
        try {
          const response = await adminUserListCsv()
          window.open(response?.file_path);
        } catch (err) {
          setApiMessage({ type: "error", message: err?.message })
        }
      }
    
      const exportPrint = async () => {
        try {
            const response = await adminUserListPdf()
            if(response) {
               printData(response)
            }
        } catch (err) {
          setApiMessage({ type: "error", message: err?.message })
        }
      }

    return (
        <AdminDashboard>
            <div className='aod-outer'>
                {apiMessage && (<Message apiMessage={apiMessage} setApiMessage={setApiMessage}></Message>)}
                <div className='ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb'>
                    <div>
                        <HomeIcon /><b onClick={() => navigate("/admin/")}>Home  /</b>   <span>Admin Users </span>

                    </div>
                    <div className="dropdown download_file_dropdown ms-auto d-flex gap-2 mb-3 flex-wrap align-items-center">
                    {pdfDownLoading ? <a className=" px-2 btn btn-danger btn-sm"> <i className="fa fa-file-pdf me-1" ></i>
                        <span>PDF</span>
                        <Spinner animation="border" className="pdf-spinner" role="status" style={{ 'marginLeft': '5px' }}>
                        <span className="visually-hidden"></span>
                        </Spinner>
                    </a> : 
                    <a className=" px-2 btn btn-danger btn-sm" onClick={() => pdfDownload()} > <i className="fa fa-file-pdf me-1" ></i> PDF</a>}
                         <a className=" px-2 btn btn-success btn-sm" onClick={() => excelDownload()}><i className="fa fa-file-excel  me-1"></i>
                            Excel </a>
                        {/* <a className=" px-2 btn btn-primary btn-sm" onClick={() => csvDownload()}><i className="fa fa-file-csv  me-1"></i>
                            CSV</a> */}
                        <a className=" px-2 btn btn-info  btn-sm" onClick={() => exportPrint()}><i className="fa fa-print me-1"></i>
                            Print</a>
                    </div>

                </div>
                <div className='admin-add-btn mb-3 d-flex justify-content-end'>
                {(grantPermissionForAddAdminUser) ? (
                        <button className='adm-tab-btn' onClick={() => navigate("/admin/admin-users/add")}><span><HiPlus />
                        </span> Add</button>
                    ) : ''}
                    </div>
                <div className="aod-inner pt-0">
                    <div className="aod-bottom">
                        <div className="adm-tabs-outer d-flex justify-content-between">
                            <h4 className='mb-0'>Admin Users </h4>
                            {/* <input className='w-25 px-2 form-control' placeholder='search' type="text" onChange={(e) => getAdminUserList(e, 'name')} /> */}
                            <div className="position-relative  w-md-50 w-25">
                                <input
                                    className="px-2 form-control"
                                    placeholder="Search"
                                    type="text"
                                    value={searchTerm} // Add a state for the input value
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value); // Update the state
                                        getAdminUserList(sortBy, 1, orderBy, e.target.value)
                                    }}
                                />
                                {searchTerm && ( // Show the clear button only when there's text
                                    <button
                                        className="btn btn-clear position-absolute"
                                        onClick={(e) => {
                                            setSearchTerm(""); // Clear the input value
                                            getAdminUserList(sortBy, 1, orderBy, e.target.value)
                                        }}
                                        style={{
                                            top: "50%",
                                            right: "10px",
                                            transform: "translateY(-50%)",
                                            border: "none",
                                            background: "transparent",
                                            fontSize: "1rem",
                                            cursor: "pointer",
                                        }}
                                    >
                                        &times; {/* This is the "X" icon */}
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="aod-head"></div>
                        {totalRecords > 0 ? <div className="row py-4 pb-0">
                          <div className="col-md-10"></div>
                          <TotalRecords totalRecords={totalRecords}></TotalRecords>
                        </div> : <></>}
                        <div className="ad-reg-table">
                            <Table size="sm" className='ad-cat-table mt-4'>
                                <thead>
                                    <tr>
                                        <th className='ad-sno'>S. No</th>
                                        <th className='ad-long cursor-pointer' onClick={(e) => getAdminUserList("name",
                                            currentPage + 1,
                                            orderBy === "asc" ? "desc" : "asc",
                                            searchData
                                            )}>Name <span><i className="fa-solid fa-sort"></i></span></th>
                                        <th className='ad-long cursor-pointer' onClick={(e) => getAdminUserList("created_at",
                                            currentPage + 1,
                                            orderBy === "asc" ? "desc" : "asc",
                                            searchData
                                            )}>Created At <span><i className="fa-solid fa-sort"></i></span></th>
                                        {(grantPermissionForEditAdminUser) ? (<>
                                            <th className='ad-long'>Status</th>
                                        </>) : ''}
                                        <th className='ad-long' style={{ paddingLeft: '30px' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        userList?.length > 0 ? userList?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{currentPage * 10 + (index + 1)}</td>
                                                <td>{item?.name ? item?.name : '--'}</td>
                                                <td>{item?.created_at ? formatDateWithSlash(item?.created_at) : '--'}</td>
                                                {grantPermissionForEditAdminUser ? 
                                                    <td>
                                                        {changingStatus === item?.id ? <span>
                                                            <span></span>
                                                            <Spinner animation="border" className="pdf-spinner status-spinner-color" role="status" style={{ 'marginLeft': '5px' }}>
                                                                <span className="visually-hidden"></span>
                                                            </Spinner>
                                                        </span> : 
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.status == 1}
                                                                onChange={(e) => handleEnableDisable(e.target.checked ? { value: "1" } : { value: "0" }, item)}
                                                            />
                                                            <span className="slider"></span>
                                                        </label>}
                                                    </td> : <></>}
                                                    <td>
                                                        <div className='icon-col'>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={<Tooltip id={`edit-tooltip-${item.id}`}>View</Tooltip>}
                                                            >
                                                                <span
                                                                    className="ad-cat-edit"
                                                                    onClick={() => { navigate("/admin/view", { state: item }) }}
                                                                >
                                                                    <EyeIcon />
                                                                </span>
                                                            </OverlayTrigger>
                                                            {grantPermissionForEditAdminUser ? 
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={<Tooltip id={`edit-tooltip-${item.id}`}>Edit</Tooltip>}
                                                            >
                                                                <span
                                                                    className="ad-cat-edit"
                                                                    onClick={() => { navigate("/admin/admin-users/update", { state: item }) }}
                                                                >
                                                                    <EditIcon />
                                                                </span>
                                                            </OverlayTrigger> : <></>}
                                                            {grantPermissionForDeleteAdminUser ? 
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={<Tooltip id={`delete-tooltip-${item.id}`}>Delete</Tooltip>}
                                                            >
                                                                <span
                                                                    className="ad-cat-delete"
                                                                    onClick={() => setDeleteData(item)}
                                                                >
                                                                    <DeleteIcon />
                                                                </span>
                                                            </OverlayTrigger> : <></>}
                                                            {grantPermissionForEditAdminUser ? <>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={<Tooltip id={`permission-tooltip-${item.id}`}>Permissions</Tooltip>}
                                                            >
                                                                <span
                                                                    className="ad-cat-permission"
                                                                    onClick={() => {
                                                                        navigate("/admin/admin-users/user-permissions/edit", { state: item })
                                                                    }}>
                                                                    <PermissionIcon />
                                                                </span>
                                                            </OverlayTrigger>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={<Tooltip id={`change-user-password-tooltip-${item.id}`}>Change Password</Tooltip>}
                                                            >
                                                                <span
                                                                    className="ad-cat-change-password"
                                                                    onClick={() => {
                                                                        navigate("/admin/admin-users/change-passwword", { state: item })
                                                                    }}>
                                                                    <CgLock />
                                                                </span>
                                                            </OverlayTrigger></> : <></>}
                                                        </div>
                                                    </td>
                                            </tr>
                                        )) : tableDataLoaded ? (
                                            <NotFoundTable colSpan="8"></NotFoundTable>
                                          ) : (
                                            <></>
                                          )}
                                </tbody>
                            </Table>
                            {totalPages > 1 && userList?.length > 0 &&
                                <div className="d-flex w-100 justify-content-end">
                                    <ReactPaginate
                                        previousLabel={"Previous"}
                                        nextLabel={"Next"}
                                        breakLabel={"..."}
                                        pageCount={totalPages} // Total number of pages from API
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={1}
                                        onPageChange={handlePageChange} // Method to handle page click
                                        containerClassName={"pagination justify-content-center"} // Custom CSS classes
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={deleteData?.id} onHide={() => setDeleteData("")}>
                <Modal.Header closeButton>
                    <Modal.Title>Do you really want to delete this User ?</Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <div className="suf-btn p-2 d-flex flex-row">
                        <button className='mx-2' onClick={() => { deleteCategory(deleteData) }}>Yes</button>
                        <button className='suf-can-butt mx-2' onClick={() => setDeleteData("")}>No</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </AdminDashboard>
    )
}

export default AdminUsers
